module.exports = __webpack_public_path__ + "static/media/profile_bg.7a111ee4.png";